export interface InitScaleAction {
    type: "INIT_SCALE";
    initialState: number;
}

export const initScale = (initialState: number): InitScaleAction => ({
    type: "INIT_SCALE",
    initialState
});

export type ScaleAction = InitScaleAction;
